class APIError extends Error {
	constructor(base, errorCode, url) {
		super(errorCode + " error for " + $wr.getNormalizedPath(url));
		this.name = base + " APIError " + errorCode;
	}
}

module.exports = APIError;


// WEBPACK FOOTER //
// ./modules/lib/shared/APIError.js